import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  state: {
  },
  mutations: {
    resetMapState (state, payload) {
      state.marker = JSON.parse(JSON.stringify(initStoreState.marker))
      state.app = JSON.parse(JSON.stringify(initStoreState.app))
      state.viewer = JSON.parse(JSON.stringify(initStoreState.viewer))
    }
  },
  actions: {
  },
  modules,
  getters
})
